import { useEffect } from "react";

//Import Breadcrumb
import { Divider } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import moment from "moment";

const NotificationDetails = ({ notificationDetails }) => {

    return (
        <>
            {/* <div className="py-3 pt-0 d-flex justify-content-between">
                <div className="text-bold font-size-20">{notificationDetails?.title}</div>
                <div className="font-size-14" style={{ color: '#A0A0A0' }}>Received on: {moment(notificationDetails?.updated_at)?.format("MMMM DD, YYYY - hh:mm A")}</div>
            </div> */}
            {/* <Divider /> */}
            <div className="">{notificationDetails?.message}</div>
            {
                notificationDetails?.changes &&
                <div className="p-4 my-3" style={{ backgroundColor: '#0000000A', borderRadius: 5 }}>
                    <div className="text-bold font-size-16">Details</div>
                    <ul>
                        {
                            notificationDetails?.changes
                                ? notificationDetails.changes.split('\n').map((line, idx) => (
                                    line ? <li key={idx}>{line?.replace("-", '')}</li> : ''
                                ))
                                : null
                        }
                    </ul>

                </div>
            }

        </>
    );
};

function mapStateToProps({ Login, Notification }) {
    return {
        userPermission: Login.permissionArry,
        notificationDetails: Notification.notificationDetails,

    };
}

export default connect(mapStateToProps)(NotificationDetails);
